module.exports = __webpack_public_path__ + "img/Imagen 7.f347d8fc.jpg";